import HeroSection from "./components/HeroSection";
import CategoryEntries from "./components/CategoryEntries";
import LatestNews from "./components/LatestNews";
import FeaturedProducts from "./components/FeaturedProducts";
import BrandIntro from "./components/BrandIntro";
import { useSEO } from "@/hooks/useSEO";

export default function Home() {
  useSEO({
    title: "白峰美羽品牌官网—全面介绍与最新动态",
    description:
      "白峰美羽官网，提供品牌介绍、最新动态与产品资讯，助您深入了解白峰美羽的文化与服务。",
    keywords: "白峰美羽,品牌介绍,白峰美羽资讯,白峰美羽动态,品牌故事,产品信息",
  });

  return (
    <>
      <HeroSection />
      <CategoryEntries />
      <LatestNews />
      <FeaturedProducts />
      <BrandIntro />
    </>
  );
}